var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBusinessHandshake = function SvgBusinessHandshake(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#business-handshake_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#808A93",
    d: "m15.386 14.977 4.011-3.628a8.57 8.57 0 0 1 6.875-2.135l5.308.703 7.366-3.98A.715.715 0 0 1 40 6.566v13.537a2.86 2.86 0 0 1-1.194 2.323l-4.96 3.546L23.1 16.957l-3.557 2.88a3.2 3.2 0 0 1-4.157-4.86"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CED3D8",
    fillRule: "evenodd",
    d: "m15.386 14.977 3.851-3.48a8.76 8.76 0 0 0-7.163-1.954l-5.245.909-5.755-3.098A.73.73 0 0 0 0 8v12.103c0 .966.477 1.868 1.274 2.411L16.86 33.14a5.84 5.84 0 0 0 6.669-.063l10.757-7.363-.032-.028-.408.288-5.372-4.503a7.14 7.14 0 0 0 2.76-1.8 1.79 1.79 0 0 0-.63-2.904 1.79 1.79 0 0 0-1.941.422c-.529.551-1.143.905-1.863 1.048-.626.12-1.423.1-2.426-.208L23.1 16.957l-3.557 2.88a3.2 3.2 0 0 1-4.157-4.86",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "business-handshake_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgBusinessHandshake;